"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionInsightProcessModal = void 0;
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const collection_insight_process_modal_ctrl_1 = require("./collection.insight.process.modal.ctrl");
const collection_insight_process_modal_style_1 = require("./collection.insight.process.modal.style");
(0, theme_1.addStyles)(collection_insight_process_modal_style_1.Style);
class CollectionInsightProcessModal extends modal_form_component_1.ModalFormComponent {
    constructor(ctx, collections) {
        super(ctx);
        this.ctrl = new collection_insight_process_modal_ctrl_1.CollectionInsightProcessModalCtrl(collections);
    }
    get nodes() {
        return (0, mithril_1.m)('div', { className: collection_insight_process_modal_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: collection_insight_process_modal_style_1.CSS.content }, [
                (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_INSIGHT_PROCESS_CONFIRM, this.ctrl.collections.length))
            ])
        ]);
    }
    submit() {
        return this.ctrl.insightProcessCollections();
    }
}
exports.CollectionInsightProcessModal = CollectionInsightProcessModal;
//# sourceMappingURL=collection.insight.process.modal.js.map